import React, { useState, useEffect } from "react";
import Pageslayout from "../../Layouts/Pageslayout";
import Select from "../../components/Select";
import Search from "../../components/Search";
import Button from "../../components/Button";
import MailBox from "../../components/MailBox";
import { useSelector, useDispatch } from "react-redux";
import PropertyItem from "../../components/PropertyItem";
import PropertyGrid from "../../components/PropertyGrid";
import Sidebar from "../../components/Sidebar";
import data from "../../data/navigationn.json";
import { setSubTypeOptions } from "../../app/reducers/selectedOptions";
const Index = () => {
  const dispatch = useDispatch();
  const properties = useSelector((state) => state.properties.data);
  const [selectedCategory, setSelectedCategory] = useState("house");
  const [selectedSubCategory, setSelectedSubCategory] = useState([]);

  const handleCategories = (name, index) => {
    setSelectedCategory(name);
    setSelectedSubCategory(data[index].categories);
    console.log("data[index].categories", data[index].categories);
  };

  const [togglecatgeories, setTogglecategories] = useState({
    Index: -1,
    State: false,
  });

  const homeCategories = [];
  const plotCategories = [];
  const commercialCategories = [];

  useEffect(() => {
    // Iterate over each object in the data array

    function handleClick() {
      setTogglecategories({
        Index: -1,
        State: false,
      });
    }
    document.body.addEventListener("click", handleClick);

    return () => {
      // 👇️ remove event listener when the component unmounts
      document.body.removeEventListener("click", handleClick);
    };
  }, []);
  data?.forEach((item) => {
    // Iterate over each category in the categories array of the current object
    item.categories.forEach((category) => {
      // Push the category name to the appropriate array based on the property type
      if (item.name === "HOMES") {
        homeCategories.push(category.name);
      } else if (item.name === "PLOTS") {
        plotCategories.push(category.name);
      } else if (item.name === "COMMERCIAL") {
        commercialCategories.push(category.name);
      }
    });
  });

  return (
    <Pageslayout pagetitle={"Properties for Sell"}>
      <div className="w-full  ">
        <div className="flex gap-4  flex-wrap lg:flex-nowrap w-full py-4  px-2 md:px-8 lg:px-8">
          <div className="w-full lg:w-1/6 hidden lg:block ">
            <Sidebar data={selectedSubCategory} />
          </div>
          <div className="lg:w-5/6  ">
            <div className="flex gap-4 justify-start px-2 items-center flex-wrap lg:hidden">
              <div className="flex gap-4 justify-start  items-center">
                <Select
                  value="Homes"
                  items={homeCategories}
                  action={setSubTypeOptions}
                />
                <Select
                  value="Plots"
                  items={plotCategories}
                  action={setSubTypeOptions}
                />
              </div>
              <div className="flex gap-4 justify-start  items-center w-full">
                <Select
                  value="Commercial"
                  items={commercialCategories}
                  action={setSubTypeOptions}
                />
                <button className=" bg-[#2a9933] max-w-[180px] rounded-md w-full text-white  flex gap-1 p-3  justify-center items-center border-black">
                  Find
                </button>{" "}
              </div>
            </div>
            <PropertyGrid properties={properties} />
          </div>
        </div>
      </div>
    </Pageslayout>
  );
};

export default Index;
